import { FormGroup } from '@angular/forms';

import { VendaItemRastreabilidade } from '../../../../../shared/services/models/vendas/venda-item-rastreabilidade.model';
import { VendaItemSerie } from '../../../../../shared/services/models/vendas/venda-item-serie.model';
import { UtilService } from '../../../../../shared/services/util.service';

/**
 * Só o excesso: soma dos lotes ou número de séries acima da quantidade do item, que o salvar do servidor recusa
 * (`ValidarCoerenciaLoteESerie`). Usada pelo Confirmar do modal do item e pelo Salvar da linha, que podem reduzir a quantidade.
 */
export function motivoDeExcessoDeLoteSerie(linha: FormGroup, casasQuantidade: number): string | null {
    const quantidade = Number(linha.get('dados.quantidade')?.value ?? 0) || 0;

    if (linha.get('dados.isControlaLotes')?.value === true) {
        const lotes = (linha.get('lotes')?.value as VendaItemRastreabilidade[] | null) ?? [];
        const soma = lotes.reduce((total, l) => total + (Number(l.quantidadeLote ?? 0) || 0), 0);

        if (UtilService.arredondarAbnt(soma, casasQuantidade) > UtilService.arredondarAbnt(quantidade, casasQuantidade)) {
            return 'A soma dos lotes selecionados passa da quantidade do item. Reduza os lotes na aba Lote/série do item ou '
                + 'aumente a quantidade.';
        }
    }

    if (linha.get('dados.isControlaSeries')?.value === true) {
        const series = (linha.get('series')?.value as VendaItemSerie[] | null) ?? [];

        if (series.length > quantidade) {
            return 'Há mais séries selecionadas do que a quantidade do item. Remova séries na aba Lote/série do item ou '
                + 'aumente a quantidade.';
        }
    }

    return null;
}

/**
 * Lote e série do item: o que ainda falta para a seleção fechar a quantidade. Produto que controla lote fecha a
 * quantidade com a soma de `quantidadeLote`, nas casas de quantidade da empresa; o que controla série tem quantidade
 * inteira e uma série por unidade. Lote e série são exclusivos no cadastro do produto (`dados.isControlaLotes`/
 * `dados.isControlaSeries`, só da tela).
 *
 * Só avisa: o pedido salva sem lote e série (D5) e o lançar estoque cobra a seleção. Usada pelo ícone da aba
 * Lote/série do modal do item. Nulo quando a seleção confere ou o produto não controla nenhum dos dois.
 */
export function motivoDaSelecaoDeLoteSerie(linha: FormGroup, casasQuantidade: number): string | null {
    const quantidade = Number(linha.get('dados.quantidade')?.value ?? 0) || 0;

    if (linha.get('dados.isControlaLotes')?.value === true) {
        const lotes = (linha.get('lotes')?.value as VendaItemRastreabilidade[] | null) ?? [];
        const soma = lotes.reduce((total, l) => total + (Number(l.quantidadeLote ?? 0) || 0), 0);

        if (UtilService.arredondarAbnt(soma, casasQuantidade) !== UtilService.arredondarAbnt(quantidade, casasQuantidade)) {
            return 'O produto controla lote: a soma dos lotes selecionados tem de ser igual à quantidade do item.';
        }
    }

    if (linha.get('dados.isControlaSeries')?.value === true) {
        const series = (linha.get('series')?.value as VendaItemSerie[] | null) ?? [];

        if (quantidade % 1 !== 0) return 'O produto controla número de série: a quantidade deve ser um número inteiro.';

        if (series.length !== quantidade) return 'O produto controla número de série: selecione uma série por unidade do item.';
    }

    return null;
}
